module.exports = __webpack_public_path__ + "static/media/SUPERIOR.bff3c89f.png";